export const iconFontAwesomeMarketingWater = (
	<i className="fa-solid fa-water"></i>
);
